module.exports = __webpack_public_path__ + "images/timothy-parsa@2x.5f917c20b1989d510d7572e0ba2ab683.jpeg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/team/timothy-parsa@2x.jpeg
// module id = 1033
// module chunks = 0